"use client";

import Value from "@/app/homepage/career/components/Value"
import Culture from "@/app/homepage/career/components/Culture";
import Benefit from "@/app/homepage/career/components/Benefit";



const COMPONENT_CAREER_MAP = {
    "value": Value,
    "benefit": Benefit,
    "culture": Culture,
};

export default function ClientRenderer({ slug }) {
    const Component = COMPONENT_CAREER_MAP[slug.toLowerCase()];
    if (!Component) return <div>해당 페이지가 없습니다.</div>;

    return <Component />;
}
